var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 9 16",
    width: 9,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.4102181 25 .4667055-2.895625h-2.9180585v-1.8790625c0-.7921875.407629-1.564375 1.7145358-1.564375h1.3265991v-2.4653125s-1.2038509-.195625-2.3548611-.195625c-2.403107 0-3.9738895 1.386875-3.9738895 3.8975v2.206875h-2.6712494v2.895625h2.6712494v7h3.2876157v-7z",
    fill: "#fff",
    fillRule: "evenodd",
    transform: "translate(-18 -16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.5899cb26.svg";
export { ForwardRef as ReactComponent };